import { Form } from "react-final-form";
import { TextField } from "mui-rff";
import { useCallback } from "react";
import { Alert, Button, Container, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { parseSignInError } from "../../utils/parseSignInError";
import { useLoginSuperAdmin } from "../../auth/useLoginSuperAdmin";

type FormValues = {
  email: string;
  password: string;
};

export const SuperAdminSigninScreen = () => {
  const [, loginLoading, loginError, loginRequest] = useLoginSuperAdmin();
  const onSubmit = useCallback(
    (formData: FormValues) => {
      loginRequest(formData.email, formData.password);
    },
    [loginRequest]
  );

  const validate = useCallback((formData: FormValues) => {
    const errors: { [key: string]: boolean } = {};

    if (!formData.email) {
      errors.email = true;
    }

    if (!formData.password) {
      errors.password = true;
    }

    return errors;
  }, []);

  return (
    <Container maxWidth='sm'>
      <Box
        height='100vh'
        pb={5}
        pt={5}
        display='flex'
        flexDirection='column'
        justifyContent='center'
      >
        <Box minHeight={400}>
          <Typography variant='h4'>Sign in to VNX ID</Typography>
          <Box mb={2} />
          <Form
            onSubmit={onSubmit}
            validate={validate}
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit} noValidate>
                <TextField
                  placeholder='admin@id.vnx.li'
                  label='Email'
                  name='email'
                  required={true}
                  size='small'
                  margin='normal'
                  type='email'
                />
                <TextField
                  label='Password'
                  name='password'
                  required={true}
                  size='small'
                  margin='normal'
                  type='password'
                />
                <Button
                  sx={{ mt: 3 }}
                  type='submit'
                  fullWidth
                  variant='contained'
                  disabled={loginLoading}
                >
                  Continue
                </Button>
                {loginError !== null && (
                  <Alert sx={{ mt: 2 }} severity='error'>
                    {loginError.message}
                  </Alert>
                )}
              </form>
            )}
          />
        </Box>
      </Box>
    </Container>
  );
};
